import React from 'react';
import { useDispatch } from 'react-redux';

import PlaceholderImage from './product-demo-thumbnail.png';

import './product-demo-video.scss';

function ProductDemoVideo() {
  const dispatch = useDispatch();
  return (
    <div className="bg-white container-fluid">
      <div className="product-demo  container py-5">
        <div className="row">
          <div className="col-12 col-sm-4 col-lg-3">
            <img
              loading="lazy"
              src={PlaceholderImage}
              alt="demo-video"
              className="tw-cursor-pointer img-fluid w-100"
              onClick={() => dispatch({ type: 'VIEW_PRODUCT_DEMO' })}
            />
          </div>
          <div className="col-12 col-sm-8 col-lg-9 text-center">
            <div>
              <span className="heading">The Cost Estimate Tool in 5 minutes</span>
            </div>
            <div className="tw-mt-4 play-button-div">
              <button
                type="button"
                className="btn btn-outline-primary btn-lg rounded"
                onClick={() => dispatch({ type: 'VIEW_PRODUCT_DEMO' })}
              >
                Play Now
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function ProductDemoVideoForSummary() {
  const dispatch = useDispatch();
  return (
    <div className="summary-section-product-demo">
      <div className="tw-flex tw-justify-center tw-flex-col tw-items-center">
        <section className="video-thumbnail">
          <img
            loading="lazy"
            src={PlaceholderImage}
            alt="demo-video"
            className="tw-cursor-pointer"
            onClick={() => dispatch({ type: 'VIEW_PRODUCT_DEMO' })}
          />
        </section>
      </div>
      <section className="features">
        <div className="tw-flex  tw-flex-col tw-items-center">
          <h5>How to use the tool?</h5>
          <p className="tw-text-center">
            We’ve made it super simple to get estimates for custom interiors. See how it works in 5
            mins!
          </p>
        </div>
        <div className="text-2-color tw-flex tw-justify-center">
          <div className="tw-w-2/4 or-div tw-flex tw-items-center">
            <h6>OR</h6>
          </div>
        </div>
        <div className="tw-flex  tw-flex-col tw-items-center tw-mt-1">
          <h5>Want us to help you? Book a free design consultation.</h5>
          <button
            type="button"
            className="tw-text-cta tw-border-cta tw-border tw-pt-2 tw-pb-2 tw-pl-4 tw-pr-4 tw-mt-4"
            onClick={() => dispatch({ type: 'VIEW_CONSULT_WITH_US' })}
          >
            Free designer support
          </button>
        </div>
      </section>
    </div>
  );
}

export { ProductDemoVideo, ProductDemoVideoForSummary };
